import React from "react";
import { ReviewCard } from "../ReviewCard/ReviewCard";
export const PlatformsReviewColumns = ({ reviews }) => (React.createElement("div", { className: "platforms-review-columns" }, Array.isArray(reviews) && reviews.map((review) => (React.createElement(ReviewCard, { key: `unique${review.review}`, ...review })))));
